const LoadingAnimation = () => {
  return <div className="loading">Loading</div>
}

export default LoadingAnimation
